import { action, computed, observable, makeObservable } from 'mobx';
import { BaseListState } from '../../../../commonv3/states/LocationListState';
import { LocationId } from '../../../../commonv3/types/locations';
import { SubmitState } from '../../../../commonv3/states/SubmitState';
import { HomeLocationApis } from '../../../apis/homeLocations';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { V3Routes } from '../../../routes';

export class HomeLocationIntroductionPageState {
  bases = new BaseListState();
  selectedLocationId = -1;
  submitState = new SubmitState();

  constructor() {
    makeObservable(this, {
      bases: observable,
      selectedLocationId: observable,
      submitState: observable,
      init: action.bound,
      selectLocation: action.bound,
      submit: action.bound,
      abort: action.bound,
      baseList: computed,
      isLocationSelected: computed,
      loading: computed,
      submitting: computed,
    });
  }

  async init() {
    await Promise.all([this.bases.init()]);
    if (GlobalStatesV3.currentUser.homeLocation.isHomeLocationSet) {
      GlobalStatesV3.routing.push(V3Routes.home());
    }
    this.selectedLocationId = -1;
  }

  selectLocation(locationId: LocationId | null) {
    this.selectedLocationId = locationId;
  }

  async submit() {
    if (!this.isLocationSelected) {
      return;
    }
    await this.submitState.operate(async () => {
      await HomeLocationApis.update(this.selectedLocationId);
      await GlobalStatesV3.currentUser.homeLocation.reload();
      GlobalStatesV3.routing.push(V3Routes.homeLocationIntroductionComplete());
    });
  }

  async abort() {
    await this.submitState.operate(async () => {
      await GlobalStatesV3.currentUser.preference.update({ confirmed_home_location_alert: true });
      GlobalStatesV3.routing.push(V3Routes.home());
    });
  }

  get baseList() {
    return this.bases.baseList;
  }

  get isLocationSelected() {
    return this.selectedLocationId == null || this.selectedLocationId > 0;
  }

  get loading() {
    return this.bases.loading || GlobalStatesV3.currentUser.homeLocation.loading;
  }

  get submitting() {
    return this.submitState.submitting;
  }
}
